import { Else, If, Then } from 'react-if';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useAuth } from '@zep/auth';
import { Language } from '@zep/types';
import { StoreCategoryString } from '../../../../consts';
import { useStoreRecommendedHashIds, useStoreRecommendedItems } from '../../../../services';
import { StoreItemType } from '../../../../types/StoreTypes';
import Empty from '../../common/Empty';
import StoreGrid from './StoreGrid';
import S from './StoreList.module.scss';

/**
 * 에셋 리스트를 출력하는 그리드에 제목이 붙은 컴포넌트
 */
const StoreRecommendedList = (storeTitledListProps: StoreRecommendedListProps) => {
  const {
    type
  } = storeTitledListProps;
  const {
    locale
  } = useRouter();
  const {
    t
  } = useTranslation(['store']);
  const {
    user
  } = useAuth();
  const isAsset = type === StoreCategoryString.map;
  const listTitleKey = isAsset ? 'store_recommended_assets' : 'store_recommended_apps';
  const recommendHashIds = useStoreRecommendedHashIds(isAsset, !!user?.isEdu);
  const items = useStoreRecommendedItems(type.toUpperCase(), recommendHashIds.data?.hashId, !!user?.isEdu, locale as Language, {
    enabled: !!recommendHashIds.data
  });
  const filteredItems = items?.data?.filter(value => value) ?? null;

  /**
   * 배열과 길이를 넣으면
   * random sorting 후 해당 길이로 잘라줌
   * @param arr
   * @param length
   */
  const handleShuffleAndCutArr = (arr: any[], length = 4) => {
    const newArr: any[] = [...arr];
    return newArr.sort(() => Math.random() - 0.5).splice(0, length);
  };
  return <div className={S.main_wrapper} style={{
    marginTop: '40px'
  }} data-sentry-component="StoreRecommendedList" data-sentry-source-file="StoreRecommendedList.tsx">
      <div className={S.title_wrapper}>
        <h3 className={S.contents_title}>{t(`store:${listTitleKey}`)}</h3>
      </div>
      <If condition={
    // @ts-ignore
    filteredItems?.length > 0} data-sentry-element="If" data-sentry-source-file="StoreRecommendedList.tsx">
        <Then data-sentry-element="Then" data-sentry-source-file="StoreRecommendedList.tsx">
          <StoreGrid items={handleShuffleAndCutArr(filteredItems ?? [])} type={type} data-sentry-element="StoreGrid" data-sentry-source-file="StoreRecommendedList.tsx" />
        </Then>
        <Else data-sentry-element="Else" data-sentry-source-file="StoreRecommendedList.tsx">
          <div className={S.empty_wrapper}>
            <Empty emptyItem={t(`store:${listTitleKey}`)} data-sentry-element="Empty" data-sentry-source-file="StoreRecommendedList.tsx" />
          </div>
        </Else>
      </If>
    </div>;
};
export default StoreRecommendedList;
type StoreRecommendedListProps = {
  type: StoreItemType;
};